/**
 * @generated SignedSource<<4c42ecdea9012b9dde15f2a14d9db32c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type TeamIcon = "account_hard_hat" | "account_tie" | "apple" | "baby_carriage" | "baguette" | "basket" | "bed" | "bread_slice" | "broom" | "carrot" | "cart" | "cash" | "cash_register" | "cheese" | "coffe" | "cookie" | "cupcake" | "default" | "desk_lamp" | "dolly" | "fish" | "flower" | "food" | "fork_knife" | "forklift" | "fridge" | "hamburger" | "hammer_wrench" | "laptop" | "market" | "meat" | "milk" | "pineapple" | "soda" | "sofa" | "steak" | "tshirt" | "tv" | "watermelon";
import { FragmentRefs } from "relay-runtime";
export type WidgetTodoOverviewSettings_Store$data = {
  readonly publicTeams: ReadonlyArray<{
    readonly color: string | null;
    readonly icon: TeamIcon | null;
    readonly id: string;
    readonly isPrivate: boolean;
    readonly name: string;
    readonly " $fragmentSpreads": FragmentRefs<"TeamSelectList_Team">;
  }>;
  readonly " $fragmentType": "WidgetTodoOverviewSettings_Store";
};
export type WidgetTodoOverviewSettings_Store$key = {
  readonly " $data"?: WidgetTodoOverviewSettings_Store$data;
  readonly " $fragmentSpreads": FragmentRefs<"WidgetTodoOverviewSettings_Store">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "WidgetTodoOverviewSettings_Store",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Team",
      "kind": "LinkedField",
      "name": "publicTeams",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "icon",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "color",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isPrivate",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "TeamSelectList_Team"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Store",
  "abstractKey": null
};

(node as any).hash = "6bf129854aa4c8fccfc46726cb83018a";

export default node;
